import { Fragment } from 'react';
import { CartItem } from '.';
import type { CartAmazonDeal, CartGetItem } from 'src/types';

type Props = {
  cartItems?: CartGetItem[];
  cartCCY?: string;
  cartCCYS?: string;
  cartVendor: string;
  cartLocale?: string;
  page?: 'get' | 'review' | 'receive' | 'embed';
  missingAsins?: string[];
  dealForItem?: (item: CartGetItem) => CartAmazonDeal | null;
};

export const CartItemsList = ({
  cartItems = [],
  cartCCY = 'USD',
  cartCCYS = '$',
  cartVendor,
  cartLocale = 'us',
  page = 'get',
  missingAsins = [],
  dealForItem,
}: Props) => {
  return (
    <ul className='flex w-full flex-col items-center justify-center'>
      {cartItems.map((item, i) => {
        const isMissing = missingAsins.includes(item.asin);
        return (
          <Fragment key={`${item.asin},${i}` || i}>
            <CartItem
              item={item}
              ccy={cartCCY}
              ccys={cartCCYS}
              vendor={cartVendor}
              compare={false}
              locale={cartLocale}
              page={page}
              isMissing={isMissing}
              deal={dealForItem?.(item)}
            />
          </Fragment>
        );
      })}
    </ul>
  );
};
